import classes from "./Button.module.css";
import { CircularProgress } from "@mui/material";

type ButtonPropTypes = {
  children: React.ReactNode;
  type?: "primary" | "secondary";
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
};

const Button = ({
  children,
  type,
  disabled,
  onClick,
  loading,
}: ButtonPropTypes) => {
  return (
    <button
      className={`${classes.button} ${
        type === "secondary" ? classes.secondary : classes.primary
      }`}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading ? <CircularProgress size="16px" color="inherit" /> : children}
    </button>
  );
};

export default Button;
